import React, { useContext } from 'react';
import { ThemeOptions, ThemeContext } from '@wix/da-react-context/pkg/ThemeContext';
const ToolbarWrapper = ({ children  })=>{
    const theme = useContext(ThemeContext);
    const themeClassName = `da-editor-theme-${theme === ThemeOptions.DARK ? 'dark' : 'bright'}`;
    return /*#__PURE__*/ React.createElement("div", {
        className: themeClassName,
        "data-daeditor-retrieved-toolbar": true
    }, children);
};
ToolbarWrapper.displayName = 'ToolbarWrapper';
export default ToolbarWrapper;
